import React, { Component } from 'react'
import { Upload, message } from 'hljd'
import { observer, inject } from 'mobx-react'
import { toJS } from 'mobx'
import Style from '../style.module.less'

@inject('store')
@observer
export default class extends Component {
  render() {
    const { value, onChange } = this.props
    const realValue = toJS(value)
    const beforeImageUpload = imageFile => {
      const size = imageFile.size / 1024 / 1024
      if (size > 20) {
        message.warning(`图片大小不能超过20MB!`)
        return false
      }
      return true
    }
    const itemRender = (originNode, file, fileList) => {
      if (fileList.findIndex(item => item.uid === file.uid) === 0) {
        return (
          <>
            {originNode}
            <div className={Style.customTag}>封面</div>
          </>
        )
      }
      return <div>{originNode}</div>
    }
    return (
      <div className={Style.menuPicsContainer}>
        <p className={Style.tips}>
          请上传3-10张真实的菜品图片，第一张图片作为封面图展示；图片比例为4:3，需在20M以内。
        </p>
        <Upload
          clipable
          max={10}
          sortable
          accept="image/*"
          listMode
          itemRender={itemRender}
          value={realValue}
          beforeUpload={beforeImageUpload}
          aspect={4 / 3}
          onChange={onChange}
        />
      </div>
    )
  }
}
